<div class="vip-dropdown-departamentos" (mouseleave)="closeSubmenu()">
  <div class="menu">
    <ul>
      <li
        *ngFor="let dep of items; let last = last"
        [class.pb-3]="last"
        class="menu-item"
        (mouseenter)="openSubmenu(dep)"
      >
        <vip-custom-link
          [url]="buildUrl(dep)"
          [openInNewTab]="false"
          [useHref]="false"
          class="flex-1 cursor-pointer block"
          [attr.data-cy]="
            'departamento-item-' + dep.classificacao_mercadologica_id
          "
          (click)="itemClick.emit(dep)"
          [ariaLabel]="
            'Ir para departamento de ' +
            stringUtilsService.capitalizeWords(dep.descricao)"
        >
          {{ stringUtilsService.capitalizeWords(dep.descricao) }}
        </vip-custom-link>

        <vip-custom-link
          *ngIf="dep.children"
          [openInNewTab]="false"
          [useHref]="false"
          class="cursor-pointer ml-1 inline-block"
          role="button"
          tabindex="0"
          [attr.aria-label]="'Abrir sub-menu ' + dep.descricao"
          (click)="openSubmenuAndFocus(dep);"
          (keydown.enter)="openSubmenuAndFocus(dep)"
          (keydown.space)="openSubmenuAndFocus(dep); $event.preventDefault()"
          >
          <i class="icon-chevron_right text-sm"></i>
        </vip-custom-link>
      </li>
    </ul>
  </div>

  <div
    #submenu
    tabindex="-1"
    [attr.aria-label]="'Sub-menu departamento ' + (departamentoAberto?.descricao ?? '')"
  >
    <vip-dropdown-secoes
      *ngIf="departamentoAberto"
      [items]="departamentoAberto.children || []"
      [hasCategories]="hasCategories"
      (itemClick)="itemClick.emit($event)"
      (mouseleave)="closeSubmenu()"
    ></vip-dropdown-secoes>
  </div>

</div>
